import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";

function ownKeys(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
      return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context4;

      _forEachInstanceProperty(_context4 = ownKeys(Object(source), true)).call(_context4, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context5;

      _forEachInstanceProperty(_context5 = ownKeys(Object(source))).call(_context5, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";
import _Object$entries from "@babel/runtime-corejs3/core-js-stable/object/entries";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import isArray from 'lodash.isarray';
import isFunction from 'lodash.isfunction';
import isPlainObject from 'lodash.isplainobject';
import merge from 'lodash.merge';
/**
 * Track event (low-level; ultra-light wrapper around `analytics.track`).
 * @param eventKey
 * @param properties (optional)
 * @param options (optional)
 */

export var trackEvent = function trackEvent(eventKey, properties, options) {
  if (!eventKey) throw new Error("Can't track event without an event key!");
  analytics.track(eventKey, properties, options);
};

var toArray = function toArray(value) {
  return isArray(value) ? value : [value];
};

var toEventDefinition = function toEventDefinition(definitionShortcut, eventKey) {
  var _toArray = toArray(definitionShortcut),
      _toArray2 = _slicedToArray(_toArray, 4),
      eventName = _toArray2[0],
      description = _toArray2[1],
      _toArray2$ = _toArray2[2],
      defaultProperties = _toArray2$ === void 0 ? {} : _toArray2$,
      _toArray2$2 = _toArray2[3],
      paramDefs = _toArray2$2 === void 0 ? {} : _toArray2$2;

  return {
    eventKey: eventKey,
    eventName: eventName,
    description: description,
    defaultProperties: defaultProperties,
    params: paramDefs
  };
};
/**
 * Normalizes a (nested) list of event definition shortcuts to create clean event definitions that can be used with `track`.
 * @param definitionShortcuts
 * @param keyPrefix
 * @returns tree of the same shape but with all leaves normalized event definitions
 *
 * @example
 *
 * ```javascript
 * const events = toEventDefinitions({
 *   // definition in root
 *   enter: 'Enter application', // simple definition, just event name
 *   // nested definitions for a specific part of the application
 *   users: {
 *     create: ['Create user', 'Clicked option to create a new user from main menu'], // event name and description
 *     // event name, description, default event properties
 *     edit: ['Edit user', 'Selected Edit user from the list of users', { productArea: 'Users', component: 'List of users' }],
 *     // event name, description, default event properties, names & descriptions of additional properties
 *     submit: ['Update user', 'Submitted changes to user', , { productArea: 'Users', component: 'Edit user' }, { username: 'Username', img: 'Profile picture' }]
 *   }
 * })
 * ```
 */


export var toEventDefinitions = function toEventDefinitions() {
  var _context;

  var definitionShortcuts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var keyPrefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return _reduceInstanceProperty(_context = _Object$entries(definitionShortcuts)).call(_context, function (acc, _ref) {
    var _context2;

    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    var fullKey = keyPrefix ? _concatInstanceProperty(_context2 = "".concat(keyPrefix, ".")).call(_context2, key) : key;
    acc[key] = (isPlainObject(value) ? toEventDefinitions : toEventDefinition)(value, fullKey);
    return acc;
  }, {});
};
/**
 * Tracks event given an event definition.
 * @param eventDefinition object (as created by `toEventDefinitions`) containing
 *  eventKey (optional) machine-friendly event key
 *  eventName (mandatory) event name
 *  description (optional) extended event description
 *  defaultProperties (optional) default properties to send
 *  params (optional) names & descriptions of additional properties
 * @param properties (optional) specific properties to send with this call
 * @param options (optional) `analytics.track` options
 */

export var track = function track(_ref3) {
  var eventKey = _ref3.eventKey,
      eventName = _ref3.eventName,
      description = _ref3.description,
      _ref3$defaultProperti = _ref3.defaultProperties,
      defaultProperties = _ref3$defaultProperti === void 0 ? {} : _ref3$defaultProperti,
      _ref3$params = _ref3.params,
      params = _ref3$params === void 0 ? {} : _ref3$params;
  var properties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = arguments.length > 2 ? arguments[2] : undefined;
  return trackEvent(eventName, _objectSpread({
    key: eventKey,
    description: description || '',
    parameterKey: params
  }, merge({}, defaultProperties, properties)), options);
};

var tap = function tap(sideEffect) {
  return function () {
    for (var _len = arguments.length, sideEffectArgs = new Array(_len), _key = 0; _key < _len; _key++) {
      sideEffectArgs[_key] = arguments[_key];
    }

    return function (fn) {
      return function () {
        var result = fn.apply(void 0, arguments);
        sideEffect.apply(void 0, sideEffectArgs).apply(void 0, arguments);
        return result;
      };
    };
  };
};

var resolve = function resolve(valueOrGetter) {
  for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  return isFunction(valueOrGetter) ? valueOrGetter.apply(void 0, args) : valueOrGetter;
};
/**
 * Decorator for tracking event when the wrapped callback is called.
 * @param eventDefinition event definition (as created by `toEventDefinitions`) containing
 *  eventKey (optional) machine-friendly event key
 *  eventName (mandatory) event name
 *  description (optional) extended event description
 *  defaultProperties (optional) default properties to send
 *  params (optional) names & descriptions of additional properties
 * @param properties (optional) one of:
 *  - an object with additional event properties
 *  - a resolver function called with wrapped function's arguments to produce the additional properties object
 */


export var trackDecorator = tap(function (eventDefinition, properties) {
  return function () {
    var _context3;

    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    return track(eventDefinition, resolve.apply(void 0, _concatInstanceProperty(_context3 = [properties]).call(_context3, args)));
  };
});